import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import idioma_lbl from "./index";

export default function Bienvenida({ handler_data, handler_obj }) {
  return (
    <React.Fragment>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item>
          <div>
          <Typography align="center" variant="body1" gutterBottom>
            {idioma_lbl === "en" ?
            "Welcome to Labelist Cosmetics skin test." 
            :
            "Bienvenid@ al diagnóstico de tu piel de Labelist Cosmetics."}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {idioma_lbl === "en" ?
            "Just by answering some questions you will discover the most suitable products " +
            "to obtain a beautiful skin!" :
            "Contestando a unas pocas preguntas descubrirás los mejores productos " +
            "para lograr tu objetivo!"}
          </Typography>
          </div>
        </Grid>
      </Grid>
      <Typography align="center" variant="h6" gutterBottom>
        {idioma_lbl === "en" ? "Give us your email to receive the results:" :
        "Déjanos tu email para recibir los resultados:"}
      </Typography>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item>
          <TextField
            inputProps={{ min: 0, style: { textAlign: "center" } }}
            required
            margin="normal"
            id="email"
            name="email"
            variant="standard"
            onChange={handler_data}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
